import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {s3FilterImagePath} from "../../../misc/utils";
import {setSelectedFilters} from "../../../actions/actionFunctions";
import {replaceFilterArrayValue} from "../../visComponents/navigation/newFilters/filterSwitchers";

const WizardFilterItem = (props) => {
  const {currentFilterValue, filterGroup, selectedFilters, setSelectedFilters, listItemHeight, isMobile} = props;

  const getFilterItemThumbnail = () => {
    const additionalImages = currentFilterValue.additionalImages;
    if (Array.isArray(additionalImages) && additionalImages.length) {
      return additionalImages[0].imageUrl
    }
    return s3FilterImagePath(currentFilterValue.icon);
  }

  const wizardFilterValueClick = () => {
    if (Array.isArray(currentFilterValue.items) && currentFilterValue.items.length) {
      debugger;//eslint-disable-line
      this.setParentFilterValues(currentFilterValue.items.map(fValue => fValue.id))
    } else {
      setSelectedFilters(replaceFilterArrayValue([...selectedFilters], {
        filterId: currentFilterValue.id,
        filterGroupId: filterGroup.id
      }));
    }
  };

  let thumbnail = getFilterItemThumbnail();
  const isColor = (filterGroup.name || "").toLowerCase().includes("color");

  const styles = {
    backgroundSize: isColor  ? "cover" : "inherit",
  };
  if (thumbnail) {
    styles.backgroundImage = "url(" + thumbnail + ")";
  }
  if (!thumbnail && currentFilterValue && isColor) {
    styles.backgroundColor = currentFilterValue.value;
  }

  const selected = selectedFilters.some(filterObject => {
    return filterObject.filterGroupId === filterGroup.id && filterObject.filterId === currentFilterValue.id
  });

  return (
    <div className={"feature" + (selected ? " feature--selected" : "")}
         style={isMobile ? {} : {height: listItemHeight}}
         onClick={wizardFilterValueClick}
         key={"feature" + currentFilterValue.id}>
      <div className="feature-thumbnail" style={styles}/>
      <div className="feature-text">{currentFilterValue.displayText}</div>
    </div>
  )

}

WizardFilterItem.propTypes = {
  filterGroup: PropTypes.object.isRequired,
  currentFilterValue: PropTypes.object.isRequired,
  listItemHeight: PropTypes.number,
}

const mapStateToProps = (store) => {
  const {selectionWindowView} = store.selectionState;
  const {selectedFilters} = store.filterState;
  const {isMobile} = store.serverState;
  return {
    selectionWindowView,
    selectedFilters,
    isMobile
  };
};

const mapDispatchToProps = {
  setSelectedFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardFilterItem)
